/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Form, Modal, Row, Col, Button, Alert, Spinner } from "react-bootstrap";
import API from "../Utility";
import { IdentityContext } from "../IdentityContext";

export default function InviteTeamMemberFormModal({ show, onCancel, onSuccess, selectedUser, modalMode }) {
  const { authUser } = useContext(IdentityContext);
  // START: Non-Generic Section
  //
  //
  //
  // Form Fields
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [email, setEmail] = useState();
  const [roles, setRoles] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const isWhitespaceString = str => !str.replace(/\s/g, '').length;
  // API Config
  const { project } = useParams(); // project needed for API
  const apiCallConfig = {
    url: `/admin/${project}/team/member`,
    data: {
      firstName: firstName ? firstName.trim() : firstName,
      lastName: lastName ? lastName.trim() : lastName,
      email: email ? email.trim() : email,
      roles: roles,
    },
  };

  useEffect(() => {
    if (modalMode === 'edit') {
      if (selectedUser && selectedUser?._id && selectedUser?.firstName !== firstName && !isEditing) {
        setFirstName(selectedUser?.firstName);
      }
      if (selectedUser && selectedUser?._id && selectedUser?.lastName !== lastName && !isEditing) {
        setLastName(selectedUser?.lastName);
      }
      if (selectedUser && selectedUser?._id && selectedUser?.email !== email && !isEditing) {
        setEmail(selectedUser?.email);
      }
      if (selectedUser && selectedUser?._id && selectedUser?.roles !== roles && !isEditing) {
        setRoles(selectedUser?.roles || []);
      }
    } else {
      resetForm();
    }
  }, [modalMode, selectedUser]);

  const addRemoveRoles = (role) => {
    setIsEditing(true);
    if (roles && roles.includes(role)) {
      setRoles(roles.filter((r) => r !== role));
    } else {
      setRoles([...roles, role]);
    }
  };
  // Form
  const form = (
    <>
      <Form.Group as={Row} controlId="firstName">
        <Col>
          <Form.Label>First Name<sup>*</sup></Form.Label>
          <Form.Control
            required
            maxLength="250"
            minLength="2"
            type="text"
            name="firstName"
            placeholder="First Name"
            defaultValue={firstName}
            onChange={(e) => {
              setIsEditing(true);
              if (isWhitespaceString(e.target.value)) {
                e.target.value = null;
              } else {
                setFirstName(e.target.value?.trim());
              }
            }}
          />
          <Form.Control.Feedback type="invalid">
                    First Name is required
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="lastName">
        <Col>
          <Form.Label>Last Name<sup>*</sup></Form.Label>
          <Form.Control
            required
            maxLength="250"
            minLength="2"
            type="text"
            name="lastName"
            placeholder="Last Name"
            defaultValue={lastName}
            onChange={(e) => {
              setIsEditing(true);
              if (isWhitespaceString(e.target.value)) {
                e.target.value = null;
              } else {
                setLastName(e.target.value?.trim());
              }
            }}
          />
          <Form.Control.Feedback type="invalid">
                    Last Name is required
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="email" style={selectedUser?._id ? { display: 'none' } : {}}>
        <Col>
          <Form.Label>Email<sup>*</sup></Form.Label>
          <Form.Control
            required
            maxLength="250"
            minLength="2"
            type="email"
            name="email"
            placeholder="Email"
            defaultValue={email}
            readOnly={selectedUser?._id}
            isInvalid={email?.length > 0 && !email?.match(/^[\w-+.]+@([\w-]+\.)+[\w-]{2,4}$/g)}
            onChange={(e) => {
              setIsEditing(true);
              if (isWhitespaceString(e.target.value)) {
                e.target.value = null;
              } else{
                setEmail(e.target.value?.trim());
              }
            }}
          />
          <Form.Control.Feedback type="invalid">
            {email?.length > 0 ? 'Email address is not valid' : 'Email is required'}
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="rolesCheck">
        <Col>
          <Form.Label>Role(s)<sup>*</sup>{
            (selectedUser?.username === authUser?.username && (authUser?.roles?.indexOf('sysadmin') === -1 || authUser?.roles?.indexOf('admin') === -1 || selectedUser?.roles?.indexOf('Admin') === -1)) ? (<div><small><i>You cannot change your own roles</i></small></div>) : ''
          }</Form.Label>
          <Row style={{ margin: '0' }}>
            <Col>
              <Row style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                <Form.Control
                  className='roles-checkbox'
                  type="checkbox"
                  value="admin"
                  name="rolesCheck"
                  checked={roles.includes('admin')}
                  onChange={(e) => addRemoveRoles(e.target.value)}
                  disabled={(selectedUser?.username === authUser?.username && (authUser?.roles?.indexOf('sysadmin') === -1 || authUser?.roles?.indexOf('admin') === -1 || selectedUser?.roles?.indexOf('Admin') === -1))}
                />
                <Form.Label style={{ margin: 0 }}>{'Project Admin'}</Form.Label>
              </Row>
            </Col>
            <Col>
              <Row style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                <Form.Control
                  className='roles-checkbox'
                  type="checkbox"
                  value="pageAdmin"
                  name="rolesCheck"
                  checked={roles.includes('pageAdmin')}
                  onChange={(e) => addRemoveRoles(e.target.value)}
                  disabled={(selectedUser?.username === authUser?.username && (authUser?.roles?.indexOf('sysadmin') === -1 || authUser?.roles?.indexOf('admin') === -1 || selectedUser?.roles?.indexOf('Admin') === -1))}
                />
                <Form.Label style={{ margin: 0 }}>{'Lesson Admin'}</Form.Label>
              </Row>
            </Col>
            <Col>
              <Row style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                <Form.Control
                  className='roles-checkbox'
                  type="checkbox"
                  value="pageDeveloper"
                  name="rolesCheck"
                  checked={roles.includes('pageDeveloper')}
                  onChange={(e) => addRemoveRoles(e.target.value)}
                  disabled={(selectedUser?.username === authUser?.username && (authUser?.roles?.indexOf('sysadmin') === -1 || authUser?.roles?.indexOf('admin') === -1 || selectedUser?.roles?.indexOf('Admin') === -1))}
                />
                <Form.Label style={{ margin: 0 }}>{'Lesson Developer'}</Form.Label>
              </Row>
            </Col>
            <Col>
              <Row style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                <Form.Control
                  className='roles-checkbox'
                  type="checkbox"
                  value="contentCreator"
                  name="rolesCheck"
                  checked={roles.includes('contentCreator')}
                  onChange={(e) => addRemoveRoles(e.target.value)}
                  disabled={(selectedUser?.username === authUser?.username && (authUser?.roles?.indexOf('sysadmin') === -1 || authUser?.roles?.indexOf('admin') === -1 || selectedUser?.roles?.indexOf('Admin') === -1))}
                />
                <Form.Label style={{ margin: 0 }}>{'Content Creator'}</Form.Label>
              </Row>
            </Col>
          </Row>
          <br></br>
          <Row style={{ margin: '0' }}>
            <Col>
              <Row style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                <Form.Control
                  className='roles-checkbox'
                  type="checkbox"
                  value="workflowManager"
                  name="rolesCheck"
                  checked={roles.includes('workflowManager')}
                  onChange={(e) => addRemoveRoles(e.target.value)}
                  disabled={(selectedUser?.username === authUser?.username && (authUser?.roles?.indexOf('sysadmin') === -1 || authUser?.roles?.indexOf('admin') === -1 || selectedUser?.roles?.indexOf('Admin') === -1))}
                />
                <Form.Label style={{ margin: 0 }}>{'Workflow Manager'}</Form.Label>
              </Row>
            </Col>
            <Col>
              <Row style={{ flexWrap: 'nowrap', alignItems: 'center' }}>
                <Form.Control
                  className='roles-checkbox'
                  type="checkbox"
                  value="workflowUser"
                  name="rolesCheck"
                  checked={roles.includes('workflowUser')}
                  onChange={(e) => addRemoveRoles(e.target.value)}
                  disabled={(selectedUser?.username === authUser?.username && (authUser?.roles?.indexOf('sysadmin') === -1 || authUser?.roles?.indexOf('admin') === -1 || selectedUser?.roles?.indexOf('Admin') === -1))}
                />
                <Form.Label style={{ margin: 0 }}>{'Workflow User'}</Form.Label>
              </Row>
            </Col>
            <Col></Col>
            <Col></Col>
          </Row>
          <Form.Control.Feedback type="invalid">
                    At least one role is required
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="roles">
        <Col>
          <Form.Control
            style={{ display: 'none' }}
            required
            maxLength="250"
            minLength="2"
            type="text"
            name="roles"
            value={roles?.toString()}
            onChange={(e) => {}}
          />
          <Form.Control.Feedback type="invalid">
            At least one role is required
          </Form.Control.Feedback>
        </Col>
      </Form.Group>
    </>
  );
  //
  //
  //
  //
  // END: End of Non-Generic Section

  const [submitError, setSubmitError] = useState();
  const [submitting, setSubmitting] = useState();
  const [formValidated, setFormValidated] = useState(false);

  const resetForm = () => {
    setFirstName();
    setLastName();
    setEmail();
    setRoles([]);
    selectedUser = null;
    setIsEditing(false);
    setSubmitError(null);
    setFormValidated(false);
  };

  const onSubmit = (e) => {
    const isValid = e.target.checkValidity();
    const apiCallAsync = async () => {
      try {
        setSubmitting(true);
        selectedUser?._id ? apiCallConfig.data._id = selectedUser._id : null;
        const apiCallRes = await selectedUser?._id ? API.put(apiCallConfig) : API.post(apiCallConfig);
        apiCallRes.then((data) => {
          if (data?.response?.status === 400 && data?.response?.data?.message) {
            setSubmitting(false);
            setSubmitError(data.response.data.message);
          } else {
            setSubmitting(false);
            onSuccess(apiCallRes);
            resetForm();
          }
        });
      } catch (err) {
        setSubmitting(false);
        if (!err.response) {
          setSubmitError(err && err.message);
        } else {
          setSubmitError(
            err &&
              err.response &&
              err.response.data &&
              err.response.data.message
          );
        }
        resetForm();
      }
    };
    setFormValidated(true);
    e.preventDefault();
    e.stopPropagation();
    if (isValid) {
      apiCallAsync();
    }
  };

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      scrollable
      show={show}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">{selectedUser?._id ? 'Update' : 'Invite'} Team Member</Modal.Title>
      </Modal.Header>
      <Form noValidate validated={formValidated} onSubmit={onSubmit} className='add-update-team-member-modal'>
        <Modal.Body>
          {form}
          {submitError && <Alert variant="danger">Error: {submitError}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          {!submitting ? (
            <div style={{ width: "100%", display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
              <Button style={{ marginRight: '10px' }} onClick={() => {
                onCancel();
                setFormValidated(null);
                resetForm();
              }} variant="outline-secondary">
                Cancel
              </Button>
              <Button variant="outline-primary" type="submit">
                {selectedUser?._id ? 'Save' : 'Send Invite'}
              </Button>
            </div>
          ) : (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
